export { getNavigateToTeamsApp } from '../src/getNavigateToTeamsApp';
